import React, { Component } from "react";
import { isIOS } from "react-device-detect";
import { Modal, ModalBody } from "reactstrap";

class OpenAndroidModal extends Component {
  checkLink() {
    setTimeout(function () {
      window.location.href = "https://cafebazaar.ir/app/ir.gity.gitymarket";
    }, 500);
    let uid =
      window.location.pathname.split("/").length === 2 &&
      window.location.pathname.split("/")[1];
    if (uid) {
      window.location = `gity://shop/${uid}`;
    } else {
      window.location = "gity://home";
    }
  }
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.props.androidModal}
          toggle={() => {
            this.props.changeModal(!this.props.androidModal);
          }}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0 text-center mb-4">
              <img
                src={require("../../base/assets/images/main_logo.svg").default}
                width="60%"
                className=""
                alt="logo"
              />
            </div>
            <div className="col-12 px-0 text-center mb-2">
              <p className="fw-bold mb-0 fs-5">نصب اپلیکیشن</p>
            </div>
            {isIOS ? (
              <div class="stand-alone__main">
                <p class="d-block">
                  ۱- در نوار پایین گوشی دکمه
                  <img
                    src={
                      require("../../base/assets/images/ios-share.png").default
                    }
                    alt="share-icon"
                    width="35"
                  />
                  را کلیک کنید.
                </p>
                <p class="d-block">
                  ۲- دکمه
                  <img
                    src={
                      require("../../base/assets/images/ios-add-to-home.png")
                        .default
                    }
                    alt="share-icon"
                    width="60"
                  />
                  را کلیک کنید
                </p>
                <p class="d-block mb-0">
                  ۳- سپس در بالای صفحه دکمه Add را کلیک کنید.
                </p>
              </div>
            ) : (
              <div className="row mx-0 px-0">
                <div className="col-12 px-0 mb-4">
                  <p className="fs-6 fw-bold text-center">
                    برای استفاده بهتر میتوانید از اپلیکیشن اندروید استفاده کنید
                  </p>
                </div>
                <div className="col-9 ps-2 pe-0">
                  <button
                    className="btn py-2 rounded14 bg-color-main w-100 text-white fw-bold"
                    onClick={() => this.checkLink()}
                  >
                    باز کردن
                  </button>
                </div>
                <div className="col-3 px-0">
                  <button
                    className="btn py-2 rounded14 bg-light-gray w-100 fw-bold"
                    onClick={() =>
                      this.props.changeModal(!this.props.androidModal)
                    }
                  >
                    انصراف
                  </button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default OpenAndroidModal;
